import {dayMonthYearAtTime, timeago} from "../../../Common/Utils/DateFormat";
import {Button, Row} from "react-bootstrap";
import HttpRequest from "../../../Common/Http/HttpRequest";
import Notify from "../../../Common/Notify/Notify";
import {useState} from "react";


export const EstouPronto = ({row, onEventUpdated}) => {


    const [showEndDescription, setShowEndDescription] = useState(false);
    const [descriptionEnd, setDescriptionEnd] = useState('');

    const closeOpenedEvent = () => {

        if (showEndDescription) {
            row.endDate = new Date();
            row.descriptionOnFinish = descriptionEnd;
            HttpRequest.put(`${process.env.REACT_APP_NODE_SERVICE}/crud/entity/cflow_work_times/${row.id}`, row).then(() => {
                Notify.success('Obrigado por registrar suas horas...');
                onEventUpdated && onEventUpdated();
            });
        } else {
            Notify.warning('Informe um detalhe do atendimento');
            setShowEndDescription(true);
        }
    }

    console.log('descriptionEnd', descriptionEnd)


    return <li>
        <div>
            <p>
                <b>{row.project.name} </b> -> {row.descriptionStart} -> {dayMonthYearAtTime(row.startTime)} ({timeago(row.startTime)})
            </p>

            <Row>
                {showEndDescription &&
                    <textarea className="mb-2" style={{width: 250, height: 150}}
                              onChange={e => setDescriptionEnd(e.target.value)}></textarea>}
            </Row>
            <Button variant="primary" title="Finalizar" onClick={() => closeOpenedEvent(row)}>
                {showEndDescription ? 'Finalizar' : 'Acabei!'}
            </Button>
        </div>
    </li>

}
